// Facility → Doctors (providers) page. Legacy: src/app/[locale]/[country]/
// account/facility/[facilityId]/providers/page.tsx — a thin auth wrapper
// around FacilityProvidersClient. The legacy page had no feature gate and no
// client-side role gate (apps/api enforces manage permissions per request);
// membership is enforced by the list endpoint (403 → no-access card inside
// the client).

import { createFileRoute } from "@tanstack/react-router";

import { AccountSecurityBanner } from "@/components/account/account-security-banner";
import { FacilityProvidersClient } from "@/components/account/facility/facility-providers-client";

export const Route = createFileRoute("/_authenticated/account/facility/$facilityId/providers")({
  component: FacilityProvidersPage,
});

function FacilityProvidersPage() {
  const { facilityId } = Route.useParams();

  return (
    <div className="space-y-8">
      <FacilityProvidersClient facilityId={facilityId} />
      <AccountSecurityBanner />
    </div>
  );
}
